var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommunityFooterSemicircleBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 252,
    viewBox: "0 0 251 252",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9822_1533",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 251,
    height: 252
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M251 251.194C251 112.789 138.405 0.194311 6.68433e-06 0.194299L4.74673e-06 22.3579C126.184 22.3579 228.836 125.017 228.836 251.194L251 251.194ZM206.283 251.194C206.283 137.45 113.744 44.9112 2.77505e-06 44.9112L8.37452e-07 67.0748C101.523 67.0748 184.12 149.671 184.12 251.188L206.283 251.188L206.283 251.194ZM161.566 251.194C161.566 162.111 89.0837 89.6347 -1.1348e-06 89.6347L-3.0724e-06 111.798C76.8623 111.798 139.396 174.332 139.396 251.194L161.56 251.194L161.566 251.194ZM116.849 251.194C116.849 186.765 64.4362 134.352 0.00661727 134.352L0.00661533 156.515C52.2149 156.515 94.6857 198.986 94.6857 251.194L116.849 251.194ZM72.1324 251.194C72.1324 211.425 39.7755 179.069 0.00661336 179.069L0.00661142 201.232C27.5542 201.232 49.9622 223.647 49.9688 251.188L72.1324 251.188L72.1324 251.194Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9822_1533)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302.982 -51.7891L-51.9922 -51.7891L-51.9921 303.185L302.982 303.185L302.982 -51.7891Z",
    fill: "url(#paint0_linear_9822_1533)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9822_1533",
    x1: -51.9922,
    y1: -51.7891,
    x2: 302.982,
    y2: 303.185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0081B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005282"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunityFooterSemicircleBlue);
export default __webpack_public_path__ + "static/media/community-footer-semicircle-blue.8309f57b023ac8b0e81331782abda1a8.svg";
export { ForwardRef as ReactComponent };